"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSource = void 0;
/**
 * DataSource defines the origin data source for an article.
 */
var DataSource;
(function (DataSource) {
    DataSource["akeneo"] = "akeneo";
    DataSource["ipro"] = "ipro";
    DataSource["stub"] = "stub";
    DataSource["mix"] = "mix";
})(DataSource = exports.DataSource || (exports.DataSource = {}));
//# sourceMappingURL=DataSource.js.map